module.exports = __webpack_public_path__ + "static/media/SpeedDegen.79f77851.mp3";